import { IAppState } from '../../types/redux';

export function selectRegionId(state: IAppState) {
  return state.regionId;
}
